import React, { useState } from 'react';
import { checkDomain } from '../apis';

const useCheckDomain = () => {
  const [loading, setLoading] = useState(false);
  const [data, setData] = useState(false);

  const get = async ({ subdomain }, callback = () => {}) => {
    try {
      if (!subdomain) {
        return false;
      }
      setLoading(true);
      setData(false);
      const response = await checkDomain({ subdomain });
      setData(response?.data);
    } catch (e) {
      console.error('Error check domain: ', e);
    } finally {
      setLoading(false);
      callback();
    }
  };

  return { loading, get, data };
};

export default useCheckDomain;
